export const breakpoints = {
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1200,
  xl: 1400,
};

// mapping the breakpoint name to the value in pixels
export const deviceSizes = {
  xs: `${breakpoints.xs}px`,
  sm: `${breakpoints.sm}px`,
  md: `${breakpoints.md}px`,
  lg: `${breakpoints.lg}px`,
  xl: `${breakpoints.xl}px`,
};

// This object is used to generate media queries. so it maps the breakpoint name to the min-width value
export const mobileFirstBreakPoints = {
  xs: 0,
  sm: breakpoints.xs,
  md: breakpoints.sm,
  lg: breakpoints.md,
  xl: breakpoints.lg,
  xxl: breakpoints.xl,
};
